import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    interpolation: { escapeValue: false },
    nsSeparator: false,    // ✅ prevent split at colons or slashes
    

    resources: {
      // ===============================
      // ENGLISH
      // ===============================
      en: {
        translation: {
          auth: {
            loginTitle: "Login",
            email: "Email",
            password: "Password",
            loginButton: "Login",
            loggingIn: "Logging in...",
            or: "OR",
            continueWithGoogle: "Continue with Google",
            dontHaveAccount: "Don’t have an account?",
            registerLink: "Register",
            successLogin: "Login successful!",
            welcome: "Welcome back",
            redirectingDashboard: "Redirecting to your dashboard...",
            registerTitle: "Register",
  fullName: "Full Name",
  registerButton: "Register",
  registering: "Registering...",
  alreadyHaveAccount: "Already have an account?",
  loginLink: "Login",
  successRegister: "Registration Successful!",
  redirectingLogin: "Redirecting to login page...",
            
          },
          dashboard: {
            nav: {
              home: "Home",
              about: "About",
              contact: "Contact",
              dashboard: "Dashboard",
            },
            welcome: "Welcome Back",
            hi: "Hi",
            welcomeMessage: "Welcome To Your Dashboard!",
            description:
              "Fill out our guided questionnaire to create a professional resume — absolutely free.",
            instruction:
              "Complete all sections for a personalized and detailed result. Every answer helps us rekindle your purpose.",
       steps: {
  questionnaire: "Questionnaire",
  consent: "Consent",
  payment: "Payment",
  results: "Results"
},
            generating: "🤖 Generating AI Results",
            analyzing:
              "Analyzing your answers... This may take a few seconds ✨",
            generatePrompt:
              "Click below to generate your personalized AI career insights.",
            generateNow: "Generate Now",
            aiInsights: "🌟 Your AI Career Insights",
            resumePhrasing: "Resume Phrasing Suggestions",
            additionalInsights: "Additional Insights",
            downloadPDF: "Download PDF",
            viewInsights: "View AI Career Insights",
            restart: "Restart ↺",
            logout: "Logout",
            footer: "Reignite.Spirit — Rekindle Purpose",
          },

          // === Questionnaire Labels ===
          "Age Group": "Age Group",
          "Gender": "Gender",
          "City / Country": "City / Country",
          "Highest Education": "Highest Education",
          "Field of Study": "Field of Study",
          "Have you worked before?": "Have you worked before?",
          "Years of Experience": "Years of Experience",
          "Preferred job type": "Preferred job type",
          "What matters most in a job?": "What matters most in a job?",
          "Open to training?": "Open to training?",
          "Team or Independent Work?": "Team or Independent Work?",
          "Willing to relocate?": "Willing to relocate?",

          // === Options ===
          "Under 18": "Under 18",
          "18–24": "18–24",
          "25–34": "25–34",
          "35–44": "35–44",
          "45–54": "45–54",
          "55+": "55+",
          "Male": "Male",
          "Female": "Female",
          "Prefer not to say": "Prefer not to say",
          "High school": "High school",
          "Diploma / Vocational": "Diploma / Vocational",
          "Bachelor’s": "Bachelor’s",
          "Master’s": "Master’s",
          "No formal qualification": "No formal qualification",
          "Science / Engineering": "Science / Engineering",
          "Business / Management": "Business / Management",
          "Arts / Humanities": "Arts / Humanities",
          "Healthcare": "Healthcare",
          "Trades / Technical": "Trades / Technical",
          "Other": "Other",
          "Yes, full-time": "Yes, full-time",
          "Yes, part-time / temporary": "Yes, part-time / temporary",
          "Internship only": "Internship only",
          "No work experience": "No work experience",
          "None": "None",
          "Less than 1 year": "Less than 1 year",
          "1–3 years": "1–3 years",
          "3–5 years": "3–5 years",
          "5+ years": "5+ years",
          "Office-based": "Office-based",
          "Outdoor / field work": "Outdoor / field work",
          "Flexible / remote": "Flexible / remote",
          "Doesn’t matter": "Doesn’t matter",
          "Stability / Security": "Stability / Security",
          "Growth opportunities": "Growth opportunities",
          "Good salary": "Good salary",
          "Work-life balance": "Work-life balance",
          "Learning new skills": "Learning new skills",
          "Yes, definitely": "Yes, definitely",
          "Maybe, if useful": "Maybe, if useful",
          "No, prefer to start work": "No, prefer to start work",
          "Prefer working in a team": "Prefer working in a team",
          "Prefer working alone": "Prefer working alone",
          "No strong preference": "No strong preference",
          "Yes": "Yes",
          "No": "No",
          "Maybe later": "Maybe later",

           // === Alerts (Popups) ===
          alerts: {
            questionnaireSaved: "✅ Questionnaire submitted successfully!",
            preferencesSaved: "🎯 Career preferences saved successfully!",
            consentSaved: "✅ Consent successfully saved!",
            aiGenerating: "🤖 Generating AI Results...",
            aiGenerated: "🌟 AI Career Insights generated successfully!",
            defaultError: "❌ Something went wrong. Please try again.",
          },

          // === AI Section ===
          ai: {
            generatingTitle: "Generating AI Results 🤖",
            generatingDesc:
              "Click below to generate your personalized AI career insights.",
            analyzing:
              "Analyzing your answers... This may take a few seconds.",
            yourInsights: "Your AI Career Insights 🌟",
            viewInsights: "View AI Career Insights",
            downloadPdf: "Download PDF",
            restart: "Restart",
          },

          // === UI ===
          "Next →": "Next →",
          "← Previous": "← Previous",
          "Submit →": "Submit →",
          "Saving your responses...": "Saving your responses...",
          "Please wait a moment while we securely store your data.":
            "Please wait a moment while we securely store your data.",
        },
      },

      // ===============================
      // ARABIC
      // ===============================
      ar: {
        translation: {
          auth: {
            loginTitle: "تسجيل الدخول",
            email: "البريد الإلكتروني",
            password: "كلمة المرور",
            loginButton: "دخول",
            loggingIn: "جاري تسجيل الدخول...",
            or: "أو",
            continueWithGoogle: "تسجيل الدخول باستخدام جوجل",
            dontHaveAccount: "ليس لديك حساب؟",
            registerLink: "إنشاء حساب",
            successLogin: "تم تسجيل الدخول بنجاح!",
            welcome: "مرحباً بك",
            redirectingDashboard: "يتم تحويلك إلى لوحة التحكم...",
             registerTitle: "إنشاء حساب",
  fullName: "الاسم الكامل",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  registerButton: "تسجيل",
  registering: "جاري التسجيل...",
  or: "أو",
  alreadyHaveAccount: "هل لديك حساب بالفعل؟",
  loginLink: "تسجيل الدخول",
  successRegister: "تم التسجيل بنجاح!",
  redirectingLogin: "يتم تحويلك إلى صفحة تسجيل الدخول...",
          },
          dashboard: {
            nav: {
              home: "الصفحة الرئيسية",
              about: "حول",
              contact: "اتصال",
              dashboard: "لوحة التحكم",
            },
            welcome: "مرحباً بعودتك",
            hi: "مرحباً",
            welcomeMessage: "مرحباً بك في لوحة التحكم الخاصة بك!",
            description:
              "قم بتحميل سيرتك الذاتية أو املأ الاستبيان الموجه لإنشاء سيرة ذاتية احترافية مجاناً.",
            instruction:
              "أكمل جميع الأقسام للحصول على نتيجة شخصية ومفصلة. كل إجابة تساعدنا على إشعال شغفك من جديد.",
           "steps": {
      "questionnaire": "Questionnaire",
      "consent": "Consent",
      "payment": "Payment",
      "results": "Results"
    },
            generating: "🤖 جاري إنشاء نتائج الذكاء الاصطناعي",
            analyzing: "يتم تحليل إجاباتك... قد يستغرق الأمر بضع ثوانٍ ✨",
            generatePrompt:
              "انقر أدناه لإنشاء رؤى مهنية مخصصة بواسطة الذكاء الاصطناعي.",
            generateNow: "أنشئ الآن",
            aiInsights: "🌟 رؤى المهنة الخاصة بك من الذكاء الاصطناعي",
            resumePhrasing: "اقتراحات صياغة السيرة الذاتية",
            additionalInsights: "رؤى إضافية",
            downloadPDF: "تحميل PDF",
            viewInsights: "عرض رؤى المهنة",
            restart: "إعادة البدء ↺",
            logout: "تسجيل الخروج",
            footer: "Reignite.Spirit — أعد إشعال هدفك",
          },
          alerts: {
            questionnaireSaved: "✅ تم إرسال الاستبيان بنجاح!",
            preferencesSaved: "🎯 تم حفظ تفضيلاتك المهنية بنجاح!",
            consentSaved: "✅ تم حفظ الموافقة بنجاح!",
            aiGenerating: "🤖 جاري إنشاء نتائج الذكاء الاصطناعي...",
            aiGenerated: "🌟 تم إنشاء نتائج الذكاء الاصطناعي بنجاح!",
            defaultError: "❌ حدث خطأ ما. يرجى المحاولة مرة أخرى.",
          },

          // === AI Section ===
          ai: {
            generatingTitle: "🤖 جاري إنشاء نتائج الذكاء الاصطناعي",
            generatingDesc:
              "اضغط أدناه لإنشاء رؤى مهنية مخصصة تعتمد على الذكاء الاصطناعي.",
            analyzing: "جاري تحليل إجاباتك... قد يستغرق الأمر بضع ثوانٍ.",
            yourInsights: "🌟 نتائجك المهنية بالذكاء الاصطناعي",
            viewInsights: "عرض النتائج",
            downloadPdf: "تحميل PDF",
            restart: "إعادة البدء",
          },

          // === Questionnaire Labels ===
// === Questionnaire Labels (16 fields) ===
"Age Group": "الفئة العمرية",
"Gender": "الجنس",
"City / Country": "المدينة / الدولة",
"Highest Education": "أعلى مؤهل دراسي",
"Field of Study": "مجال الدراسة",
"Have you worked before?": "هل سبق لك العمل؟",
"Years of Experience": "سنوات الخبرة",
"Preferred Work Types": "أنواع العمل المفضلة",
"Skills": "المهارات",
"Computer Proficiency": "إجادة استخدام الحاسوب",
"Languages you can Read/Write": "اللغات التي يمكنك قراءتها وكتابتها",
"Languages you can Speak": "اللغات التي تتحدثها",
"Preferred job type": "نوع العمل المفضل",
"What matters most in a job?": "ما الأهم بالنسبة لك في الوظيفة؟",
"Open to training?": "هل أنت منفتح على التدريب؟",
"Team or Independent Work?": "هل تفضل العمل ضمن فريق أم بشكل مستقل؟",
"Willing to relocate?": "هل ترغب بالانتقال إلى مكان آخر؟",

// === Common Options ===
"Under 18": "أقل من 18 عامًا",
"18–24": "من 18 إلى 24 عامًا",
"25–34": "من 25 إلى 34 عامًا",
"35–44": "من 35 إلى 44 عامًا",
"45–54": "من 45 إلى 54 عامًا",
"55+": "55 عامًا فأكثر",

"Male": "ذكر",
"Female": "أنثى",
"Prefer not to say": "أفضل عدم الإفصاح",

"High school": "الثانوية العامة",
"Diploma / Vocational": "دبلوم / تدريب مهني",
"Bachelor’s": "بكالوريوس",
"Master’s": "ماجستير",
"No formal qualification": "بدون مؤهل رسمي",

"Science / Engineering": "العلوم / الهندسة",
"Business / Management": "الأعمال / الإدارة",
"Arts / Humanities": "الفنون / الإنسانيات",
"Healthcare": "الرعاية الصحية",
"Trades / Technical": "الحرف / التقنية",
"Other": "أخرى",

"Yes, full-time": "نعم، بدوام كامل",
"Yes, part-time / temporary": "نعم، بدوام جزئي / مؤقت",
"Internship only": "تدريب فقط",

"No work experience": "بدون خبرة عمل",
"None": "لا يوجد",
"Less than 1 year": "أقل من سنة",
"1–3 years": "من سنة إلى 3 سنوات",
"1-3 years": "من سنة إلى 3 سنوات",
"3–5 years": "من 3 إلى 5 سنوات",
"3-5 years": "من 3 إلى 5 سنوات",
"5+ years": "أكثر من 5 سنوات",


// === Work Types ===
"Technical / IT": "تقني / تكنولوجيا المعلومات",
"Administrative / Clerical": "إداري / مكتبي",
"Sales / Marketing": "مبيعات / تسويق",
"Customer Service": "خدمة العملاء",
"Management / Leadership": "إدارة / قيادة",
"Healthcare / Support": "رعاية صحية / دعم",
"Education / Training": "تعليم / تدريب",
"Creative": "إبداعي",
"Skilled Trade": "حرفي ماهر",
"Other": "أخرى",

// === Skills ===
"Talking to people / communication": "التحدث مع الآخرين / التواصل",
"Organizing / planning": "التنظيم / التخطيط",
"Problem solving / logic": "حل المشكلات / المنطق",
"Working with numbers": "العمل بالأرقام",
"Creative thinking / design": "التفكير الإبداعي / التصميم",
"Teamwork / leadership": "العمل الجماعي / القيادة",
"Manual or hands-on tasks": "مهام يدوية / تطبيقية",
"Using tools / technology": "استخدام الأدوات / التكنولوجيا",
"Helping or caring for others": "مساعدة أو رعاية الآخرين",
"Research / analysis": "البحث / التحليل",

// === Computer Proficiency ===
"Basic (Word, Excel, Email)": "أساسي (وورد، إكسل، بريد إلكتروني)",
"Intermediate (Spreadsheets, Presentations)": "متوسط (جداول بيانات، عروض تقديمية)",
"Advanced (Programming, Databases)": "متقدم (برمجة، قواعد بيانات)",
"Design Tools (Photoshop, Figma)": "أدوات التصميم (فوتوشوب، فيجما)",
"No computer skills": "بدون مهارات حاسوبية",

// === Languages ===
"English": "الإنجليزية",
"Arabic": "العربية",
"Tamil": "التاميلية",
"Hindi": "الهندية",
"Malayalam": "المالايالامية",
"French": "الفرنسية",
"Other": "أخرى",

// === Job Preferences ===
"Office-based": "مكتبي",
"Outdoor / field work": "ميداني / خارجي",
"Flexible / remote": "مرن / عن بُعد",
"Doesn’t matter": "لا يهم",

// === Job Priorities ===
"Stability / Security": "الاستقرار / الأمان الوظيفي",
"Growth opportunities": "فرص النمو والتطور",
"Good salary": "راتب جيد",
"Work-life balance": "توازن الحياة والعمل",
"Learning new skills": "تعلم مهارات جديدة",

// === Training & Team ===
"Yes, definitely": "نعم بالتأكيد",
"Maybe, if useful": "ربما إذا كان مفيدًا",
"No, prefer to start work": "لا، أُفضل البدء بالعمل مباشرة",

"Prefer working in a team": "أفضل العمل ضمن فريق",
"Prefer working alone": "أفضل العمل بمفردي",
"No strong preference": "لا تفضيل قوي",

// === Relocation ===
"Yes": "نعم",
"No": "لا",
"Maybe later": "ربما لاحقًا",

          // === UI ===
          "Next →": "التالي →",
          "← Previous": "← السابق",
          "Submit →": "إرسال →",
          "Saving your responses...": "جاري حفظ إجاباتك...",
          "Please wait a moment while we securely store your data.":
            "يرجى الانتظار لحظة أثناء حفظ بياناتك بأمان.",
        
        },
                  // === Personality Orientation ===
          "Personality Orientation": "التوجه الشخصي 🌟",
          "Do you prefer working:": "هل تفضل العمل:",
          "With people": "مع الناس",
          "With tasks/objects": "مع المهام أو الأشياء",
          "Both equally": "كلاهما بنفس القدر",
          "Do you enjoy:": "هل تستمتع بـ:",
          "Structured routines": "جداول منظمة",
          "Variety and change": "تنوع وتغيير",
          "No preference": "بدون تفضيل",
          "When making decisions, you rely more on:":
            "عند اتخاذ القرارات، تعتمد أكثر على:",
          "Logic and facts": "المنطق والحقائق",
          "Feelings and intuition": "المشاعر والحدس",
          "Do you usually:": "هل عادةً ما تقوم بـ:",
          "Plan ahead carefully": "التخطيط بعناية مسبقًا",
          "Adapt as things happen": "التكيف مع الأحداث أثناء حدوثها",
          "In a group, you feel more comfortable:":
            "في مجموعة، تشعر براحة أكبر عندما:",
          "Leading the group": "تقود المجموعة",
          "Supporting and helping": "تدعم وتساعد الآخرين",
          "Working quietly on your own": "تعمل بهدوء بمفردك",
          // === Personality Orientation ===
          "Personality Orientation": "التوجه الشخصي 🌟",
          "Do you prefer working:": "هل تفضل العمل:",
          "With people": "مع الناس",
          "With tasks/objects": "مع المهام أو الأشياء",
          "Both equally": "كلاهما بنفس القدر",
          "Do you enjoy:": "هل تستمتع بـ:",
          "Structured routines": "جداول منظمة",
          "Variety and change": "تنوع وتغيير",
          "No preference": "بدون تفضيل",
          "When making decisions, you rely more on:":
            "عند اتخاذ القرارات، تعتمد أكثر على:",
          "Logic and facts": "المنطق والحقائق",
          "Feelings and intuition": "المشاعر والحدس",
          "Do you usually:": "هل عادةً ما تقوم بـ:",
          "Plan ahead carefully": "التخطيط بعناية مسبقًا",
          "Adapt as things happen": "التكيف مع الأحداث أثناء حدوثها",
          "In a group, you feel more comfortable:":
            "في مجموعة، تشعر براحة أكبر عندما:",
          "Leading the group": "تقود المجموعة",
          "Supporting and helping": "تدعم وتساعد الآخرين",
          "Working quietly on your own": "تعمل بهدوء بمفردك",
      },
       auth: {
            registerTitle: "إنشاء حساب",
            loginTitle: "تسجيل الدخول",
            fullName: "الاسم الكامل",
            email: "البريد الإلكتروني",
            password: "كلمة المرور",
            registerButton: "تسجيل",
            loginButton: "دخول",
            or: "أو",
            continueWithGoogle: "تسجيل الدخول باستخدام جوجل",
            alreadyHaveAccount: "هل لديك حساب بالفعل؟",
            dontHaveAccount: "ليس لديك حساب؟",
            loginLink: "تسجيل الدخول",
            registerLink: "إنشاء حساب",
            registering: "جاري التسجيل...",
            loggingIn: "جاري تسجيل الدخول...",
            welcome: "مرحباً بك",
            successRegister: "تم التسجيل بنجاح!",
            successLogin: "تم تسجيل الدخول بنجاح!",
            redirectingLogin: "يتم تحويلك إلى صفحة تسجيل الدخول...",
            redirectingDashboard: "يتم تحويلك إلى لوحة التحكم...",
          },
        
    },
  });

// === Remember selected language on refresh ===
const savedLang = localStorage.getItem("lang");
if (savedLang) i18n.changeLanguage(savedLang);

export default i18n;

